/** Joins class names, dropping falsy values. Replaces the `classnames` package. */
export function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}
